export const filterMapping = {
  status: "status",
  poktan: "poktanId",
  kategoriBrigade: "alsintanCategoryId",
  alsinstan: "alsintanId",
  kategoriPengajuan: "typeApplication",
  instansi: "instansiId",
  roles: "roleId",
  users: "usersId",
} as const;

export type FilterKey = keyof typeof filterMapping;

export type Option = { label: string; value: string };
